/* Reveal au defilement des sections .qsn- (meme comportement que ventilia.fr).
   Les etats de repos sont neutralises par prefers-reduced-motion cote CSS. */
(function () {
  function ready() {
    var hero = document.querySelector('.qsn-hero');
    if (hero) {
      window.requestAnimationFrame(function () { hero.classList.add('is-ready'); });
    }
    var targets = document.querySelectorAll('.qsn-mani,.qsn-chiff,.qsn-eng,.qsn-conv,.qsn-cit,.qsn-cta');
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(targets, function (t) { t.classList.add('is-vis'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-vis');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    Array.prototype.forEach.call(targets, function (t) { io.observe(t); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
  document.addEventListener('shopify:section:load', ready);
})();
